import Route from "@ember/routing/route";

export default class ViewTermsOfUseRoute extends Route {}
